export default "__VITE_ASSET__EZNIr5cw__"